import { render, staticRenderFns } from "./RoyTextInTable.vue?vue&type=template&id=1034fd62&"
import script from "./RoyTextInTable.vue?vue&type=script&lang=js&"
export * from "./RoyTextInTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports